import { Directive, Input, OnDestroy } from '@angular/core';
import { TitleService } from '~services/title.service';

@Directive({
  selector: '[ctPageTitle]',
})
export class PageTitleDirective implements OnDestroy {
  @Input('ctPageTitle') public set pageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  constructor(private titleService: TitleService) {}

  public ngOnDestroy() {
    this.titleService.setTitle(null);
  }
}
